'use client'
import React, { useEffect, useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import Image from 'next/image'
import qrCodeImage from '../../assets/images/QR_code_download.png'
import appStoreImage from '../../assets/images/App_store_download.png'
import iphoneImage from '../../assets/images/iphone_pro_img.png'
import lifeStyleOneImage from '../../assets/images/lifestyle-1.jpg'
import { useQuery } from '@tanstack/react-query'
import fetchRoomTypes from '@/app/lib/api/roomTypes'
import fetchRoomLabels from '@/app/lib/api/fetchRoomLabels'
import { useUserSession } from '@/app/lib/context/UserSessionContext'
interface Texture {
    id: string;
    surfaceType: 'Wall' | 'Floor';
    type: 'color' | 'image';
    name: string;
    hexCode: string;
    textureUrl?: string;
    category?: 'Wood' | 'Carpet' | 'Tile' | 'Concrete';
}

interface TextureData {
    textures: Texture[];
}
const currentViewConstants = {
    roomPlanOnBoarding: 'ROOM_PLAN_ON_BOARDING',
    createRoomPlan: "CREATE_ROOM_PLAN",
    scanRoomPlan: 'SCAN_ROOM_PLAN'
}

const textures: TextureData = {
    textures: [
        { id: "DFCDB1", hexCode: "#DFCDB1", surfaceType: "Wall", type: "color", name: "DFCDB1" },
        { id: "86775F", hexCode: "#86775F", surfaceType: "Wall", type: "color", name: "86775F" },
        { id: "DFD8CD", hexCode: "#DFD8CD", surfaceType: "Wall", type: "color", name: "DFD8CD" },
        { id: "908779", hexCode: "#908779", surfaceType: "Wall", type: "color", name: "908779" },
        { id: "CDDBDF", hexCode: "#CDDBDF", surfaceType: "Wall", type: "color", name: "CDDBDF" },
        { id: "749AA5", hexCode: "#749AA5", surfaceType: "Wall", type: "color", name: "749AA5" },
        { id: "A6AADF", hexCode: "#A6AADF", surfaceType: "Wall", type: "color", name: "A6AADF" },
        { id: "6067C1", hexCode: "#6067C1", surfaceType: "Wall", type: "color", name: "6067C1" },
        { id: "B8A27E", hexCode: "#B8A27E", surfaceType: "Wall", type: "color", name: "B8A27E" },
        { id: "635237", hexCode: "#635237", surfaceType: "Wall", type: "color", name: "635237" },
        { id: "C5BEB3", hexCode: "#C5BEB3", surfaceType: "Wall", type: "color", name: "C5BEB3" },
        { id: "605749", hexCode: "#605749", surfaceType: "Wall", type: "color", name: "605749" },
        { id: "98B0B8", hexCode: "#98B0B8", surfaceType: "Wall", type: "color", name: "98B0B8" },
        { id: "5A7078", hexCode: "#5A7078", surfaceType: "Wall", type: "color", name: "5A7078" },
        { id: "3F459E", hexCode: "#3F459E", surfaceType: "Wall", type: "color", name: "3F459E" },
        { id: "1C2165", hexCode: "#1C2165", surfaceType: "Wall", type: "color", name: "1C2165" },
        { id: "t5", textureUrl: "/ai/floors/wood/Oak.png", surfaceType: 'Floor', type: 'image', name: 'Oak', category: 'Wood', hexCode: "" },
        { id: "t6", textureUrl: "/ai/floors/wood/Maple.png", surfaceType: 'Floor', type: 'image', name: 'Maple', category: 'Wood', hexCode: "" },
        { id: "t7", textureUrl: "/ai/floors/wood/Cherry.png", surfaceType: 'Floor', type: 'image', name: 'Cherry', category: 'Wood', hexCode: "" },
        { id: "t8", textureUrl: "/ai/floors/wood/Walnut.png", surfaceType: 'Floor', type: 'image', name: 'Walnut', category: 'Wood', hexCode: "" },
        { id: "t9", textureUrl: "/ai/floors/wood/Ash.png", surfaceType: 'Floor', type: 'image', name: 'Ash', category: 'Wood', hexCode: "" },
        { id: "t10", textureUrl: "/ai/floors/wood/Mahogany.png", surfaceType: 'Floor', type: 'image', name: 'Mahogany', category: 'Wood', hexCode: "" },

        { id: "t11", textureUrl: "/ai/floors/carpet/Nylon.png", surfaceType: 'Floor', type: 'image', name: 'Nylon', category: 'Carpet', hexCode: "" },
        { id: "t12", textureUrl: "/ai/floors/carpet/Polyester.png", surfaceType: 'Floor', type: 'image', name: 'Polyester', category: 'Carpet', hexCode: "" },
        { id: "t13", textureUrl: "/ai/floors/carpet/Acrylic.png", surfaceType: 'Floor', type: 'image', name: 'Acrylic', category: 'Carpet', hexCode: "" },
        { id: "t14", textureUrl: "/ai/floors/carpet/Wool.png", surfaceType: 'Floor', type: 'image', name: 'Wool', category: 'Carpet', hexCode: "" },
        { id: "t15", textureUrl: "/ai/floors/carpet/Pile.png", surfaceType: 'Floor', type: 'image', name: 'Pile', category: 'Carpet', hexCode: "" },

        { id: "t16", textureUrl: "/ai/floors/tile/Ceramic.png", surfaceType: 'Floor', type: 'image', name: 'Ceramic', category: 'Tile', hexCode: "" },
        { id: "t17", textureUrl: "/ai/floors/tile/Stone.png", surfaceType: 'Floor', type: 'image', name: 'Stone', category: 'Tile', hexCode: "" },
        { id: "t18", textureUrl: "/ai/floors/tile/Mosaic.png", surfaceType: 'Floor', type: 'image', name: 'Mosaic', category: 'Tile', hexCode: "" },
        { id: "t19", textureUrl: "/ai/floors/tile/Glass.png", surfaceType: 'Floor', type: 'image', name: 'Glass', category: 'Tile', hexCode: "" },
        { id: "t20", textureUrl: "/ai/floors/tile/Terracotta.png", surfaceType: 'Floor', type: 'image', name: 'Terracotta', category: 'Tile', hexCode: "" },

        { id: "t21", textureUrl: "/ai/floors/concrete/Polished.png", surfaceType: 'Floor', type: 'image', name: 'Polished', category: 'Concrete', hexCode: "" },
        { id: "t22", textureUrl: "/ai/floors/concrete/Stained.png", surfaceType: 'Floor', type: 'image', name: 'Stained', category: 'Concrete', hexCode: "" },
        { id: "t23", textureUrl: "/ai/floors/concrete/Stamped.png", surfaceType: 'Floor', type: 'image', name: 'Stamped', category: 'Concrete', hexCode: "" },
        { id: "t24", textureUrl: "/ai/floors/concrete/Epoxy.png", surfaceType: 'Floor', type: 'image', name: 'Epoxy', category: 'Concrete', hexCode: "" },
        { id: "t25", textureUrl: "/ai/floors/concrete/Micro-Topping.png", surfaceType: 'Floor', type: 'image', name: 'Micro-Topping', category: 'Concrete', hexCode: "" },
    ]
}
interface RoomPlanOnBoardingProps {
    modalOpen: boolean;
    setModalOpen: any;
}
const RoomPlanOnBoarding: React.FC<RoomPlanOnBoardingProps> = (props) => {
    const { sessionInfo } = useUserSession()
    const { modalOpen, setModalOpen } = props
    const [currentView, setCurrentView] = useState(currentViewConstants.roomPlanOnBoarding)
    const [name, setName] = useState('');
    const [lengthFeet, setLengthFeet] = useState(12);
    const [lengthInches, setLengthInches] = useState(0);
    const [widthFeet, setWidthFeet] = useState(15);
    const [widthInches, setwidthInches] = useState(0);
    const [formError, setFormError] = useState("");
    const [showWallPicker, setShowWallPicker] = useState(false);
    const [showFloorPicker, setShowFloorPicker] = useState(false);
    const wallOptions = textures.textures.filter(t => t.surfaceType === 'Wall');
    const [selectedWall, setSelectedWall] = useState(wallOptions[0]);
    const floorCategories = [...new Set(textures.textures.filter(t => t.surfaceType === 'Floor').map(t => t.category))];
    const [selectedCategory, setSelectedCategory] = useState(floorCategories[0]);
    const floorOptions = textures.textures.filter(t => t.surfaceType === 'Floor' && t.category === selectedCategory);
    const [selectedFloor, setSelectedFloor] = useState(floorOptions[0]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const [selectedRoomType, setSelectedRoomType] = useState('');
    //query
    const { data: roomLabelsData, isFetching: isFetchingRoomLabels, isError: isErrorRoomLabels, error: errorRoomLabels, refetch: refetchRoomLabels } = useQuery({
        queryKey: ['room-labels', selectedRoomType], queryFn: ({ queryKey }) => fetchRoomLabels(queryKey[1], sessionInfo?.session?.identityId || ''), enabled: false
    })
    const { data: roomTypesData, isLoading: isLoadingRoomTypes, isError: isErrorRoomTypes, error: errorRoomTypes } = useQuery({
        queryKey: ['room-types'], queryFn: fetchRoomTypes, staleTime: 3600000
    })
    //handlers
    function handleOnChangeName(event: React.ChangeEvent<HTMLInputElement>) {
        setName(event.target.value);
        if (event.target.value.trim().length > 0) {
            setDisableNextButton(false);
        } else {
            setDisableNextButton(true);
        }

    }
    //effects
    useEffect(() => {
        //inorder to auto select roomtype
        if (roomTypesData?.roomTypes?.length) {
            const firstActive = roomTypesData.roomTypes.find(
                (type: any) => type.status.toLowerCase() === 'active'
            );
            if (firstActive) {
                setSelectedRoomType(firstActive.roomType);
            }
        }
    }, [roomTypesData]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            if (name.trim().length > 0) {
                refetchRoomLabels()
            }
        }, 300)
        return () => {
            clearTimeout(timerId)
        }
    }, [name])
    useEffect(() => {
        if (roomLabelsData && name.trim().length > 0) {
            const roomLabelAlreadyPresent = roomLabelsData.data.some((eachRoomLabel: any) => eachRoomLabel.roomLabel === name)
            if (roomLabelAlreadyPresent) {
                setFormError("The room label already exists. Please choose a different label.")
                setDisableNextButton(true)
            } else {
                setFormError("")
                setDisableNextButton(false)
            }
        }
    }, [roomLabelsData, name])
    //ui
    function getCurrentView(currentView: string) {
        function renderRoomPlanOnBoardingView() {
            return (
                <div className="grid grid-cols-1 md:grid-cols-[60%_40%] relative">
                    {/* OR label */}
                    <div className="hidden md:block absolute left-[60%] -translate-x-1/2 top-[10%] z-10 bg-white px-3 text-lg font-semibold text-gray-500">
                        or
                    </div>

                    {/* Vertical Divider */}
                    <div className="hidden md:block absolute left-[60%] top-[15%] h-[70%] w-px bg-gray-300 z-0" />

                    {/* Left Section - Sample Rooms */}
                    <div className="p-6 md:p-10 z-10">
                        <h2 className="text-3xl font-semibold text-center mb-6">
                            To create your room plan, <br />
                            choose a sample room
                        </h2>

                        <div className="grid grid-cols-2 gap-4">
                            {[
                                { name: 'Living Room', img: 'https://nestingale.com/catalog-assets/designs/1000099-gtr-6379-design.jpg', route: '/myrooms?userType=designer&showCaseRoomType=livingroom' },
                                { name: 'Dining Room', img: 'https://nestingale.com/catalog-assets/designs/70000024-bonito_burnt_orange_velvet-5_piece.jpg', route: '/myrooms?userType=designer&showCaseRoomType=diningroom' },
                                { name: 'Bedroom', img: 'https://nestingale.com/catalog-assets/designs/1000112-luzon-quinton-bedroom-design.jpg', route: '/myrooms?userType=designer&showCaseRoomType=bedroom' },
                                { name: 'Office', img: 'https://nestingale.com/catalog-assets/designs/1220006-plank-office-design.jpg', route: '/myrooms?userType=designer&showCaseRoomType=office' },
                            ].map((room) => (
                                <div key={room.name} className="flex flex-col items-center cursor-pointer">
                                    <div className="w-full h-28 bg-gray-100 rounded-lg overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-md">
                                        <Image
                                            onClick={() => { window.location.href = room.route }}
                                            src={room.img}
                                            alt={room.name}
                                            width={100}
                                            height={100}
                                            className="object-cover w-full h-full"
                                        />
                                    </div>
                                    <span className="mt-2 text-sm font-medium">{room.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Section - Custom Options */}
                    <div className="p-6 md:p-10 flex flex-col items-center justify-center space-y-6 z-10">
                        <h3 className="text-3xl font-semibold text-center text-blue-900">
                            Create your own or <br />
                            use an existing one
                        </h3>

                        <div
                            className="w-full max-w-[320px] h-[100px] flex justify-center cursor-pointer items-stretch "
                            onClick={(event: any) => {
                                event.stopPropagation();
                                setCurrentView(currentViewConstants.scanRoomPlan);
                            }}
                        >
                            <Image
                                src={iphoneImage}
                                alt="Scan room"
                                className="rounded-l-lg h-full w-auto object-cover"
                            />
                        </div>
                        <button
                            onClick={() => {
                                setCurrentView(currentViewConstants.createRoomPlan);
                            }}
                            className="w-full text-teal-600 py-4 px-7 border-2 border-teal-600! rounded-lg font-semibold cursor-pointer"
                        >
                            Create your room plan in just a few clicks.
                        </button>
                        <button onClick={() => { window.location.href = '/myrooms?userType=designer' }} className="w-full border-2 border-[#25282B]! text-[#25282B] py-3 px-4 rounded-lg cursor-pointer">
                            Already have a room plan? <br />
                            Choose a saved room from your account.
                        </button>
                    </div>
                </div>
            );
        }
        function renderCreateRoomPlanView() {
            //handlers
            function handleOnClickNext() {
                if (selectedRoomType.trim().length <= 0) {
                    setFormError('please select room type')
                    return
                }
                if (name.trim().length <= 0) {
                    setFormError('please enter valid room name')
                    return
                }
                if (lengthFeet <= 0) {
                    setFormError('please enter a valid length in feet')
                    return
                }
                if (widthFeet <= 0) {
                    setFormError('please enter a valid width in feet')
                    return
                }
                const length = `${lengthFeet}'${lengthInches}`;
                const width = `${widthFeet}'${widthInches}`;
                const wallColor = selectedWall.hexCode.substring(1);
                const floorType = selectedFloor.category;
                const floorTypeValue = selectedFloor.name;
                const url = `/builder?roomType=${selectedRoomType}&createRoom=true&auth=false&roomLabel=${name}&l=${length}&w=${width}&wc=${wallColor}&ft=${floorType}&ftv=${floorTypeValue}&saveProject=true&interiorDesigner=true`;
                window.location.href = url;
            }
            return (
                <div className="flex items-center justify-center space-y-6">
                    <div className="rounded-3xl w-[90%] max-w-5xl p-6 py-12 relative bg-white">
                        <div className="flex items-center justify-between w-[100%]">
                            <div className="aspect-square rounded-full overflow-hidden">
                                <Image
                                    src={lifeStyleOneImage}
                                    alt="Nestingale logo"
                                    className="object-cover w-full h-full"
                                    width={340}
                                    height={340}
                                />
                            </div>
                            <div className='flex flex-col'>

                                <h2 className="text-2xl font-semibold mb-4 text-center md:text-left">
                                    Tell us a bit more about this room:
                                </h2>
                                <div className="grid grid-cols-[150px_1fr] gap-y-4 gap-x-2">

                                    {/* Room Type */}
                                    <label className="text-xl">Room Type:</label>
                                    {isLoadingRoomTypes ? (
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-gray-200 dark:bg-gray-700 mb-2.5"></div>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    ) : (isErrorRoomTypes ? <p className='text-red-500 italic'>something went wrong while fetching room types</p> :
                                        <select
                                            value={selectedRoomType}
                                            onChange={(e: any) => setSelectedRoomType(e.target.value)}
                                            className="p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 cursor-pointer"
                                        >
                                            {roomTypesData?.roomTypes?.map((option: any) => (
                                                <option key={option.roomTypeId} value={option.roomType} disabled={option.status.toLowerCase() !== 'active'}>
                                                    {option.roomTypeDisplayName}
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    {/* Name */}
                                    <label htmlFor="name" className="text-xl">Name:</label>
                                    <input
                                        id="name"
                                        placeholder="Enter room label"
                                        value={name}
                                        onChange={handleOnChangeName}
                                        className="w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400"
                                    />
                                    {/* Length */}
                                    <label className="text-xl">Length:</label>
                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="number"
                                            min={0}
                                            value={lengthFeet}
                                            onChange={(e: any) => setLengthFeet(e.target.value)}
                                            className="w-[25%] p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                                        />
                                        <span className='self-end'>ft</span>
                                        <input
                                            type="number"
                                            min={0}
                                            value={lengthInches}
                                            onChange={(e: any) => setLengthInches(e.target.value)}
                                            className="w-[25%] p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                                        />
                                        <span className='self-end'>in</span>
                                    </div>

                                    {/* Width */}
                                    <label className="text-xl">Width:</label>
                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="number"
                                            min={0}
                                            value={widthFeet}
                                            onChange={(e: any) => setWidthFeet(e.target.value)}
                                            className="w-[25%] p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                                        />
                                        <span className='self-end'>ft</span>
                                        <input
                                            type="number"
                                            min={0}
                                            value={widthInches}
                                            onChange={(e: any) => setwidthInches(e.target.value)}
                                            className="w-[25%] p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                                        />
                                        <span className='self-end'>in</span>
                                    </div>
                                    {/* Wall + Floor Pickers in one row */}
                                    <div className="col-span-2 grid grid-cols-2 gap-x-4 items-center">
                                        {/* Wall Color */}
                                        <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setShowWallPicker(true)}>
                                            <label className="text-xl mb-0">Wall Color:</label>
                                            <div className="w-8 h-8 rounded-full" style={{ backgroundColor: selectedWall?.hexCode }} />
                                        </div>

                                        {/* Floor Type */}
                                        <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setShowFloorPicker(true)}>
                                            <label className="text-xl mb-0">Floor Type:</label>
                                            <div className="w-8 h-8 rounded-full overflow-hidden">
                                                <img src={selectedFloor.textureUrl} alt="Floor Type" className="w-full h-full object-cover" />
                                            </div>
                                        </div>
                                    </div>
                                    {formError && <p className='col-span-2 text-red-500 italic'>{formError}</p>}
                                    {/* Next Button */}
                                    <div className="col-span-2 text-center md:text-left mt-4">
                                        <button
                                            className="px-15 py-2.5 rounded-full bg-orange-500 text-white cursor-pointer disabled:cursor-not-allowed"
                                            onClick={handleOnClickNext}
                                            disabled={disableNextButton || isErrorRoomLabels || isFetchingRoomLabels}
                                        >
                                            NEXT
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Wall Picker Modal */}
                        {showWallPicker && (
                            <div className="absolute inset-0 bg-opacity-30 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-xl shadow-lg relative w-72">
                                    <h3 className="text-center font-semibold mb-4">SELECT YOUR WALL TYPE</h3>
                                    <div className="grid grid-cols-5 gap-3">
                                        {wallOptions.map((t: Texture) => (
                                            <div
                                                key={t.id}
                                                className={`w-8 h-8 rounded-full cursor-pointer ${selectedWall.id === t.id ? '!border-3 !border-emerald-600' : 'border-transparent border'}`}
                                                style={{ backgroundColor: t.hexCode }}
                                                onClick={() => {
                                                    setSelectedWall(t);
                                                    setShowWallPicker(false);
                                                }}
                                            />
                                        ))}
                                    </div>
                                    <button className="absolute top-2 right-2 cursor-pointer" onClick={() => setShowWallPicker(false)}>✕</button>
                                </div>
                            </div>
                        )}

                        {/* Floor Picker Modal */}
                        {showFloorPicker && (
                            <div className="absolute inset-0 bg-opacity-30 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-xl shadow-lg relative w-[320px]">
                                    <h3 className="text-center font-semibold mb-2">SELECT YOUR FLOOR TYPE</h3>
                                    <div className="flex justify-around mb-4 border-b pb-2">
                                        {floorCategories.map(category => (
                                            <button
                                                key={category}
                                                className={`text-sm px-2 ${selectedCategory === category ? 'border border-teal-600 text-teal-600 font-semibold rounded' : 'text-gray-500'}`}
                                                onClick={() => setSelectedCategory(category)}
                                            >
                                                {category}
                                            </button>
                                        ))}
                                    </div>
                                    <div className="flex gap-4 overflow-x-auto pb-2">
                                        {floorOptions.map((t: Texture) => (
                                            <div
                                                key={t.id}
                                                className="w-16 shrink-0 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedFloor(t);
                                                    setShowFloorPicker(false);
                                                }}
                                            >
                                                <img src={t.textureUrl} alt={t.name} className={`rounded-md w-full h-12 object-cover mb-1 ${selectedFloor.id === t.id ? '!border-3 !border-emerald-600' : 'border-transparent border'} `} />
                                                <p className="text-center text-sm">{t.name}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <button className="absolute top-2 right-2 cursor-pointer" onClick={() => setShowFloorPicker(false)}>✕</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        function renderScanRoomPlanView() {
            return (
                <div className="rounded-xl max-w-5xl w-full flex overflow-hidden">
                    {/* Left Side - Room Image */}
                    <div className="w-[60%] flex items-center justify-center p-5.5 relative">
                        <div className="w-100 h-100 rounded-full overflow-hidden aspect-square">
                            <Image
                                src={lifeStyleOneImage}
                                alt="Nestingale logo"
                                className="object-cover w-full h-full"
                                width={240}
                                height={240}
                            />
                        </div>
                    </div>

                    {/* Right Side - Text + QR */}
                    <div className="w-[40%] p-5.5 flex flex-col justify-center items-center text-center">
                        <h2 className="text-2xl font-semibold mb-2">You’re almost there!</h2>
                        <p className="text-gray-600 mb-4">
                            Scan the code to download our app now and<br />
                            scan your room to create a room plan.
                        </p>

                        <Image src={appStoreImage} alt="App Store" className="w-40 mb-4" />
                        <Image src={qrCodeImage} alt="QR Code" className="w-40 h-40 mb-4" />

                        <p className="text-gray-600 text-sm mb-2">
                            After you’ve scanned your room on the app, visit<br />
                            your rooms page to start designing it.
                        </p>

                        <button className="bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-semibold cursor-pointer" onClick={() => { window.location.href = '/myrooms' }}>
                            LET’S GO
                        </button>
                    </div>
                </div>
            )
        }

        switch (currentView) {
            case currentViewConstants.roomPlanOnBoarding:
                return renderRoomPlanOnBoardingView()
            case currentViewConstants.createRoomPlan:
                return renderCreateRoomPlanView()
            case currentViewConstants.scanRoomPlan:
                return renderScanRoomPlanView()
            default:
                return null
        }
    }
    //root return
    return (
        <Dialog open={modalOpen} onClose={setModalOpen} className="relative z-50">
            <DialogBackdrop className="fixed inset-0 bg-black/30" />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                <DialogPanel className="relative w-full max-w-6xl rounded-2xl bg-white shadow-xl overflow-hidden">
                    {/* Back button */}
                    <button
                        className="absolute top-4 left-4 text-gray-400 hover:text-gray-600 cursor-pointer z-500"
                        onClick={() => { setCurrentView(currentViewConstants.roomPlanOnBoarding) }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                    </button>
                    {/* Close button */}
                    <button
                        onClick={() => { setModalOpen(false); setCurrentView(currentViewConstants.roomPlanOnBoarding) }}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer z-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    {/* Content */}
                    {getCurrentView(currentView)}
                </DialogPanel>
            </div>
        </Dialog>
    )
}

export default RoomPlanOnBoarding